<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <p>Cliquez ici pour être rédirigé vers la page de paiement</p>
        </div>
        <CreditCardForm></CreditCardForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";
import CreditCardForm from "./CreditCardForm";

export default {
    components: { CreditCardForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
